import { makeAutoObservable } from 'mobx';
import { StoriesIncutBlock } from '@graphql/types';
import IStoriesIncutStore from './IStoriesIncutStore';

class StoriesIncutStore implements IStoriesIncutStore {
    addingBlocksCache: Map<string, StoriesIncutBlock> = new Map<string, StoriesIncutBlock>();
    deletingBlocksCache: Set<string> = new Set<string>();

    storiesIncutBlocks: StoriesIncutBlock[] = [];
    storiesIncutBlocksUids: string[] = [];
    confirmSaveModalOpen = false;
    incutCursor: string | undefined = undefined;
    incutHasNextPage: boolean = false;
    nextTab: number | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setStoriesIncutBlocks = (val: StoriesIncutBlock[]): void => {
        this.storiesIncutBlocks = val;
    };

    setStoriesIncutBlocksUids = (val: string[]): void => {
        this.storiesIncutBlocksUids = val;
    };

    setIncutCursor = (cursor: string | undefined): void => {
        this.incutCursor = cursor;
    };

    setIncutHasNextPage = (hasNextPage: boolean): void => {
        this.incutHasNextPage = hasNextPage;
    };

    setNextTab = (nextTab: number): void => {
        this.nextTab = nextTab;
    };

    resetCache = (): void => {
        this.addingBlocksCache.clear();
        this.deletingBlocksCache.clear();
    };

    setConfirmSaveModalOpen = (val: boolean): void => {
        this.confirmSaveModalOpen = val;
    };
}

export default StoriesIncutStore;